import { Map as OlMap } from "ol";
 
import View from 'ol/View';
import { fromLonLat, transformExtent } from 'ol/proj';
import proj4 from 'proj4';
import { register } from 'ol/proj/proj4';
import { defaults as defaultInteractions } from 'ol/interaction';
import {
  Attribution,
  BottomRight,
  Footer,
  GeoLocate,
  MousePosition,
  Overview,
  ScaleLine,
  TopRight,
  Zoom,
  Layer as LayerControl
} from '../../bgis/ol/control';
import { toggleClass } from '../../bgis/util/dom';
import { selectEvent, hoverEvent } from './interaction';
import { wertvolleLandwBoedenLayer, adminLayer, digitaleKatastralmappeLayer, basemapGrayLayer, basemapOrthofotoLayer, noBasemapLayer,  selectionLayer, hoverLayer,  searchLayer } from '../layers';
import { FeatureLike } from "ol/Feature";
/* autria extent limit */
proj4.defs(
  'EPSG:31287',
  '+proj=lcc +lat_1=49 +lat_2=46 +lat_0=47.5 +lon_0=13.33333333333333 +x_0=400000 +y_0=400000 +ellps=bessel +towgs84=577.326,90.129,463.919,5.137,1.474,5.297,2.4232 +units=m +no_defs',
);
register(proj4); /* register the projection in ol core */

const austria_extent_epsg3857 = transformExtent([107778, 286080, 694884, 575954], 'EPSG:31287', 'EPSG:3857');


const baseMapLayerControl = new LayerControl();

baseMapLayerControl.addEventListener("click", (event) => { toggleClass('.bgis-map-area', 'show-basemap'); event.stopPropagation(); return false });



const createNewMap = () => {

 console.log( wertvolleLandwBoedenLayer );

  const map = new OlMap({
    view: new View({
      center: fromLonLat([13.4, 47.7]), // center of austria
      showFullExtent: true, // ensure that user can zoom out to austrias extent.
      maxZoom: 19, // limit min displayable scale to 1:2256.99 = close to 1:2000
      //minZoom: 7, not needed --> is implizit set ba showFullExtent:true
      zoom: 7,
      extent: austria_extent_epsg3857, // limit the displayable extent to austria.
    }),
    layers: [basemapGrayLayer, basemapOrthofotoLayer, noBasemapLayer,   wertvolleLandwBoedenLayer ,    digitaleKatastralmappeLayer, adminLayer ,  selectionLayer,  hoverLayer, searchLayer ],
    controls: [
      new TopRight([new GeoLocate(), new Zoom()]),
      new Footer([
        new ScaleLine(),
        new MousePosition(),
        new Attribution(),
      ]),
      new BottomRight({
        horizontalControls:
          [baseMapLayerControl,
          ],
        verticalControls: []
      }),
      new Overview()
    ],
    interactions: defaultInteractions(), // extend the map default interactions with the h2owebgis specificinteraction
    target: undefined
  });

   map.on("pointermove", hoverEvent);

   map.on('click', selectEvent);

  return map;
}

interface MapState {
  h2oMap: OlMap, // the map 
  hoverFeature?: FeatureLike,
  selectedFeatures: Map<string,FeatureLike>,

}

/**
 * Stores the map (is not serailizeable therefor not stored in redux store)
 */
export const mapState: MapState = {
  h2oMap: createNewMap(),
  hoverFeature: undefined,
  selectedFeatures: new Map<string,FeatureLike>(),
}